import { render, staticRenderFns } from "./ShiftieLoading.vue?vue&type=template&id=455aff5e&scoped=true&"
import script from "./ShiftieLoading.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ShiftieLoading.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ShiftieLoading.vue?vue&type=style&index=0&id=455aff5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455aff5e",
  null
  
)

export default component.exports